import {
  COMMISSIONS_GET_COMISSION_DATA_BEGIN,
  COMMISSIONS_GET_COMISSION_DATA_SUCCESS,
  COMMISSIONS_GET_COMISSION_DATA_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_COMISSION_DATA_BEGIN:
      return {
        ...state,
        commissionList: {
          ...state.commissionList,
          getComissionDataPending: true
        }
      }
    case COMMISSIONS_GET_COMISSION_DATA_SUCCESS:
      return {
        ...state,
        commissionList: {
          ...state.commissionList,
          ...action.data,
          refreshDate:action.data.refreshDate,
          getComissionDataPending: false
        }
      }

    case COMMISSIONS_GET_COMISSION_DATA_FAILURE:
      return {
        ...state,
        commissionList: {
          error: action.data,
          getCommissionDataPending: false
        }
      }
    default:
      return state
  }
}
